import * as deployConfig from './deploy.json';

export const deploy = deployConfig as { version: string };